import React from 'react'
import { Box, Button, Typography } from '@mui/material'

import { AppBrandMark, AppNote } from '@components'
import { dsColorNew } from '@palette'


const linkSx = { minWidth: 0, p: '2px 4px', textTransform: 'none', fontSize: 13, fontWeight: 500, color: dsColorNew.appBlue }

const meAsSx = on => ({
	minWidth: 0, px: 1, py: '1px', fontSize: 12, fontWeight: on ? 600 : 500, textTransform: 'none', borderRadius: '6px',
	color: on ? dsColorNew.appBlue : dsColorNew.textMuted, backgroundColor: on ? dsColorNew.pillActiveBg : 'transparent',
})

// "YOU <brand> Change" — the brand comes from Settings › Account (CU-869fknfmk). With `meAs` (CU-869fmjzrh D2) it also
// says whether You is your brand or your website: `onMeAs('brand' | 'site')`; Season passes neither
export default function IdentityChip({ brand, onChange, meAs = null, onMeAs = null }) {
	return <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, height: 30, pl: 1.25, pr: 0.75, borderRadius: '8px', backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, fontSize: 13 }}>
		<Typography component="span" sx={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.6, textTransform: 'uppercase', color: dsColorNew.textSubtle }}>You</Typography>
		<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, fontWeight: 600, color: dsColorNew.textTitle }}>
			<AppBrandMark name={brand} size={18}/>{brand}
		</Box>
		{!!meAs && <Box role="group" aria-label="Me as" sx={{ display: 'inline-flex', gap: '2px', p: '2px', borderRadius: '8px', backgroundColor: dsColorNew.pillTrackBg }}>
			<Button size="small" aria-pressed={meAs === 'brand'} onClick={() => onMeAs?.('brand')} sx={meAsSx(meAs === 'brand')}>Brand</Button>
			<Button size="small" aria-pressed={meAs === 'site'} onClick={() => onMeAs?.('site')} sx={meAsSx(meAs === 'site')}>Website</Button>
		</Box>}
		<Button variant="text" size="small" onClick={onChange} sx={linkSx}>Change</Button>
	</Box>
}

// CA 17: without a brand the screen still works; this line says how to get your row and your position
export function NoIdentityNote({ onGo, children = null }) {
	return <AppNote severity="info">
		{children || <>Set your brand in <b>Settings › Account</b> to see your row and your position.</>}{' '}
		<Button variant="text" size="small" onClick={onGo} sx={{ ...linkSx, color: 'inherit', textDecoration: 'underline', verticalAlign: 'baseline' }}>Go to Settings › Account</Button>
	</AppNote>
}
